module.exports = __webpack_public_path__ + "static/media/06-06.8ed095bc.png";